// Rewrites direct S3 media links to their CloudFront distribution.
//
// The API returns cover art, avatars, and audio as plain S3 URLs. Those bypass
// the CDN, so every image is fetched from us-east-1 with no edge cache and no
// browser cache header. Each media bucket already has a CloudFront
// distribution in front of it; this maps one to the other.
//
// Presigned URLs (private files) are left alone: their signature is bound to
// the S3 host and would fail through CloudFront.

const CDN_BY_BUCKET = {
  "siki-production": "d2pdxmptx6ftfp.cloudfront.net",
  "siki-staging": "d3u4prkqagliv8.cloudfront.net",
};

// Matches both virtual-hosted styles S3 emits:
//   https://<bucket>.s3.amazonaws.com/<key>
//   https://<bucket>.s3.<region>.amazonaws.com/<key>
//   https://<bucket>.s3-<region>.amazonaws.com/<key>
const S3_URL = /^https?:\/\/([a-z0-9.-]+)\.s3(?:[.-][a-z0-9-]+)?\.amazonaws\.com\/([^?#]+)(\?[^#]*)?$/i;

export function toCdnUrl(url) {
  if (typeof url !== "string") return url;
  const match = S3_URL.exec(url);
  if (!match) return url;
  const [, bucket, key, query] = match;
  const cdnHost = CDN_BY_BUCKET[bucket.toLowerCase()];
  if (!cdnHost) return url;
  if (query && /x-amz-signature=/i.test(query)) return url;
  return `https://${cdnHost}/${key}`;
}

/**
 * Walks an API response and rewrites every S3 media URL in place.
 * Bounded depth guards against cyclic or absurdly nested payloads.
 */
export function rewriteMediaUrls(value, depth = 0) {
  if (depth > 12 || value === null || typeof value !== "object") return value;
  if (Array.isArray(value)) {
    for (let i = 0; i < value.length; i++) {
      const v = value[i];
      if (typeof v === "string") value[i] = toCdnUrl(v);
      else if (v && typeof v === "object") rewriteMediaUrls(v, depth + 1);
    }
    return value;
  }
  for (const k of Object.keys(value)) {
    const v = value[k];
    if (typeof v === "string") value[k] = toCdnUrl(v);
    else if (v && typeof v === "object") rewriteMediaUrls(v, depth + 1);
  }
  return value;
}
